module.exports = __webpack_public_path__ + "img/number_7.1709653c.png";